import { writable } from "svelte/store";
import type { StateSetting } from "@shared/types/StateSetting";

const initialStateSetting: StateSetting = {
  central_lonlat: "",
  class_b: false,
  cod_enabled: false,
  id: null,
  show_discount_schedule: false,
  state: "",
  uses_distribution_areas: false,
  uses_future_pricing: false,
  uses_future_pricing_with_min_bottle: false,
};
const StateSettingsStore = writable<StateSetting>(initialStateSetting);

export default StateSettingsStore;
